<template>
  <div id="user-interface-preferences" class="user-interface-preferences">
    <template v-if="showLanguage">
      <div class="ui-pref-section ui-pref-language">
        <div class="ui-pref-language__text">
          <h3 class="ui-pref-label">
            {{ $t('app.settings.language.title') }}
          </h3>
          <div id="current-language" class="ui-pref-value">
            {{ currentLanguageName }}
          </div>
        </div>
        <v-btn
          id="edit-language"
          icon
          class="ui-pref-edit"
          @click="editLanguage"
        >
          <v-icon>{{ icons.mdiPencil }}</v-icon>
        </v-btn>
      </div>

      <v-divider class="ui-pref-divider"></v-divider>
    </template>

    <div class="ui-pref-section">
      <h3 class="ui-pref-label">
        {{ $t('app.user_interface.heart_rate_input_method.title') }}
      </h3>
      <v-radio-group
        id="heart-rate-input-method"
        v-model="heartRateInput"
        row
        hide-details
        class="custom-radio-group mt-1"
      >
        <v-radio
          v-for="method in inputMethods"
          :key="`heart-rate-${method.value}`"
          :id="`heart-rate-${method.value}`"
          :label="$t(method.token)"
          :value="method.value"
          class="custom-radio"
          color="primary"
        ></v-radio>
      </v-radio-group>
    </div>

    <v-divider class="ui-pref-divider"></v-divider>

    <div class="ui-pref-section">
      <h3 class="ui-pref-label">
        {{ $t('app.user_interface.respiratory_rate_input_method.title') }}
      </h3>
      <v-radio-group
        id="respiratory-rate-input-method"
        v-model="respiratoryRateInput"
        row
        hide-details
        class="custom-radio-group mt-1"
      >
        <v-radio
          v-for="method in inputMethods"
          :key="`respiratory-rate-${method.value}`"
          :id="`respiratory-rate-${method.value}`"
          :label="$t(method.token)"
          :value="method.value"
          class="custom-radio"
          color="primary"
        ></v-radio>
      </v-radio-group>
    </div>
  </div>
</template>

<script>
import { mapState, mapStores } from 'pinia'
import icons from '@/mixins/icons'
import { useLanguageStore } from '@/stores/language'
import { usePreferenceStore } from '@/stores/preference'
import './styles/user-interface-preferences.css'

const INPUT_METHODS = [
  { value: 'tapper', token: 'app.user_interface.tapper.title' },
  { value: 'slider', token: 'app.user_interface.slider.title' },
]

export default {
  name: 'UserInterfacePreferences',
  mixins: [icons],
  props: {
    showLanguage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputMethods: INPUT_METHODS,
    }
  },
  computed: {
    currentLanguageName() {
      const code = this.selectedLanguage || 'en'
      const base = code.split('-')[0]

      try {
        const name = new Intl.DisplayNames([code], { type: 'language' }).of(base)
        return name ? name.charAt(0).toUpperCase() + name.slice(1) : code
      }
      catch (e) {
        return code
      }
    },
    ...mapState(useLanguageStore, { selectedLanguage: 'selected' }),
    ...mapState(usePreferenceStore, ['getHeartRateInputMethod', 'getRespiratoryRateInputMethod']),
    ...mapStores(usePreferenceStore),
    heartRateInput: {
      get() {
        return this.getHeartRateInputMethod
      },
      set(value) {
        this.preferenceStore.heartRateInputMethod = value
      },
    },
    respiratoryRateInput: {
      get() {
        return this.getRespiratoryRateInputMethod
      },
      set(value) {
        this.preferenceStore.respiratoryRateInputMethod = value
      },
    },
  },
  methods: {
    editLanguage() {
      this.$router.push({ name: 'Language', query: { from: 'user_interface' } }).catch(error => {
        if (error.name !== 'NavigationDuplicated') throw error
      })
    },
  },
}
</script>
